import type { PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useLocation } from 'react-router'
import { NotFoundPage } from '~/pages/not-found'
import { UnknownErrorPage } from '~/pages/unknown-error'
import { PageBase } from './page-base'

function ErrorPage({
  children,
  resetErrorBoundary,
}: PropsWithChildren<{ resetErrorBoundary: () => void }>) {
  return <PageBase onLogoClick={resetErrorBoundary}>{children}</PageBase>
}

export function AppErrorBoundary({ children }: PropsWithChildren) {
  const location = useLocation()

  return (
    <ErrorBoundary
      resetKeys={[location.pathname]}
      fallbackRender={({ error, resetErrorBoundary }) => {
        if (error.status === 404) {
          return (
            <ErrorPage resetErrorBoundary={resetErrorBoundary}>
              <NotFoundPage resetErrorBoundary={resetErrorBoundary} />
            </ErrorPage>
          )
        }
        return (
          <ErrorPage resetErrorBoundary={resetErrorBoundary}>
            <UnknownErrorPage resetErrorBoundary={resetErrorBoundary} />
          </ErrorPage>
        )
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
